"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDiversityResourceCached = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useOdrModels_1 = require("./useOdrModels");
var ModelIdentifier;
(function (ModelIdentifier) {
    ModelIdentifier["Male"] = "9a6b9b54fae52a5598c03604f2d9acd6";
    ModelIdentifier["Female"] = "964db2dd4f98052f03baa9ca5f2dbcae";
})(ModelIdentifier || (ModelIdentifier = {}));
function useIsDiversityResourceCached(diversityKey, modelType) {
    const odrModels = (0, useOdrModels_1.useOdrModels)();
    let isOdrResourcesCached = false;
    if (!odrModels) {
        return isOdrResourcesCached;
    }
    const femaleModelOdrState = odrModels.find(model => model.identifier == ModelIdentifier.Female);
    const maleModelOdrState = odrModels.find(model => model.identifier == ModelIdentifier.Female);
    const femaleResourcesState = femaleModelOdrState === null || femaleModelOdrState === void 0 ? void 0 : femaleModelOdrState.diversityResourcesState;
    const maleResourcesState = maleModelOdrState === null || maleModelOdrState === void 0 ? void 0 : maleModelOdrState.diversityResourcesState;
    let isFemaleResourcesCached = false;
    let isMaleResourcesCached = false;
    if (femaleResourcesState && diversityKey) {
        let currentFemaleDiversityState = femaleResourcesState.find(diversityResource => diversityResource.diversityKey === diversityKey);
        if (currentFemaleDiversityState) {
            isFemaleResourcesCached = !!currentFemaleDiversityState.isCached;
        }
        else {
            /**
             * If there is no diversityResourcesState matching the diversityKey
             * Then the resources are in the bundle or are not ODR resources e.g. E-7, X-7, X-X
             */
            isFemaleResourcesCached = true;
        }
    }
    if (maleResourcesState && diversityKey) {
        let currentMaleDiversityState = maleResourcesState.find(diversityResource => diversityResource.diversityKey === diversityKey);
        if (currentMaleDiversityState) {
            isMaleResourcesCached = !!currentMaleDiversityState.isCached;
        }
        else {
            /**
             * If there is no diversityResourcesState matching the diversityKey
             * Then the resources are in the bundle or are not ODR resources e.g. E-7, X-7, X-X
             */
            isMaleResourcesCached = true;
        }
    }
    if (modelType === bridge_schema_1.ModelType.Male) {
        isOdrResourcesCached = isMaleResourcesCached;
    }
    else if (modelType === bridge_schema_1.ModelType.Female) {
        isOdrResourcesCached = isFemaleResourcesCached;
    }
    else {
        isOdrResourcesCached = isMaleResourcesCached && isFemaleResourcesCached;
    }
    return !!isOdrResourcesCached;
}
exports.useIsDiversityResourceCached = useIsDiversityResourceCached;
